module.exports = __webpack_public_path__ + "img/katarina_bedrooms_13.c1a93a64.jpg";